module.exports = __webpack_public_path__ + "static/media/Icn-mid.30972e66.svg";